export default __webpack_public_path__ + "static/media/zelalem.6f58b75d.jpg";